export const launchdarklyKeys = {
  showOfflineDonations: 'show-offline-donations',
  npoFeatureEnabled: 'admin-dashboard-npo-admin-emails',
  stripoEmailBuilderPages: 'admin-dashboard-stripo-email-builder-pages',
  amplitudeSessionReplayEnabled: 'admin-dashboard-amplitude-session-replay-enabled',
  ticketSaleClientNotifications: 'admin-dashboard-ticket-sale-client-notification',
  showTicketPurchase: 'show-ticket-purchase',
  showGuestDefaultInfo: 'show-default-guest-info',
  enableArchivedCampaignsFilter: 'admin-dashboard-archived-campaign-filtering',
  useNpDashLogin: 'use-np-dash-login',
  useNpDashContacts: 'use-np-dash-contacts',
  useNpDashDonationForms: 'use-np-dash-donation-forms',
  useNpDashCampaigns: 'use-np-dash-campaigns',
  useNpDashEmailDomain: 'use-np-dash-email-domain',
  useNpDashDashboard: 'use-np-dash-dashboard',
  useNpDashSegments: 'use-np-dash-segments',
  useNpDashMessagingEmail: 'np-dash-messaging-email',
  useNpDashMessagingSms: 'use-np-dash-messaging-sms',
  useNpDashMessaging: 'use-np-dash-messaging',
  useNpDashImportExport: 'use-np-dash-import-export',
}
